import { SVGProps } from 'react'

const RiskIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.62 14h-.884l.946-12h.682L4.62 14ZM12.294 14h-.868l-.744-12h.667l.945 12ZM10.388 4.186h-4.76l.046-1.116h4.667l.047 1.116ZM13.922 4.186h-1.984l-.093-1.116h1.922l.155 1.116ZM14.248 6.605h-2.093l-.108-1.24h2.03l.171 1.24ZM14.605 9.318h-2.217l-.124-1.396h2.155l.186 1.396ZM14.977 12.341h-2.341l-.14-1.55h2.28l.2 1.55ZM4.093 4.186H2.109l.155-1.116h1.922l-.093 1.116ZM3.876 6.605H1.798l.155-1.24h2.032l-.109 1.24ZM3.643 9.318H1.442l.186-1.396h2.14l-.125 1.396ZM3.364 12.341h-2.34l.2-1.55h2.28l-.14 1.55ZM10.527 6.605H5.504l.062-1.24h4.9l.061 1.24ZM10.667 9.318H5.349l.062-1.396h5.178l.078 1.396ZM10.837 12.341H5.194l.077-1.55h5.473l.093 1.55Z"
    />
  </svg>
)
export default RiskIcon
